import React from 'react';
import { Button } from 'antd';
import { ButtonGroupProps as ButtonGroupCopyProps } from 'antd/lib/button/button-group';

export type ButtonGroupProps = ButtonGroupCopyProps;

const ProButtonGroup: React.FC<ButtonGroupProps> = (props) => {
  const { children, ...resProps } = props;
  return <Button.Group {...resProps}>{children}</Button.Group>;
};

export default ProButtonGroup;
